import { type InferType, array, object, string } from "yup";

import { MAX_DESCRIPTION_LENGTH, MAX_TAGS, MAX_TAG_LENGTH } from "./limits";
import { messages } from "./messages.generated";

// TODO(i18n): Only handles English traslation
// need to update solution to allow i18n
const {
    lensDiscoverabilityTagsLabel: { defaultMessage: tagsLabel },
    lensDiscoverabilityDescriptionLabel: { defaultMessage: descriptionLabel },
    lensDiscoverabilityLocationsLabel: { defaultMessage: locationsLabel },
    lensDiscoverabilityDaysTimesHolidaysLabel: { defaultMessage: daysTimesHolidaysLabel },
} = messages;

export const LensDiscoverabilityFormSchema = object({
    description: string().label(descriptionLabel).max(MAX_DESCRIPTION_LENGTH),
    tagsList: array().label(tagsLabel).of(string().max(MAX_TAG_LENGTH).required()).max(MAX_TAGS),
    locationsList: array().label(locationsLabel).of(string().max(MAX_TAG_LENGTH).required()).max(MAX_TAGS),
    daysTimesHolidaysList: array()
        .label(daysTimesHolidaysLabel)
        .of(string().max(MAX_TAG_LENGTH).required())
        .max(MAX_TAGS),
}).required();

export type LensDiscoverabilityFormValues = InferType<typeof LensDiscoverabilityFormSchema>;
